<template>
  <el-dialog append-to-body :visible.sync="showTag" width="70%">
    <div slot="title">
      请选择要预约到 <span
        class="color_main">{{ info.date }} 周{{ info.week }} {{ info.timeIntervalStartTime }}~{{ info.timeIntervalEndTime }} {{ info.sortNumber }}号</span>
      的人员
    </div>

    <el-form :inline="true" size="mini" :model="form">
      <el-form-item>
        <el-input v-model="val" style="width: 300px">
          <el-select v-model="k" slot="prepend" placeholder="请选择" style="width: 100px;">
            <el-option :label="item.name" :value="item.id" v-for="item in ks"
                       :key="item.id"></el-option>
          </el-select>
        </el-input>
      </el-form-item>
      <el-form-item label="体检套餐">
        <el-input v-model="form.comboName"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="formReset">重置</el-button>
        <el-button type="primary" @click="getData">筛选</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list" border size="mini">
      <el-table-column label="姓名" prop="healthcheckerName"></el-table-column>
      <el-table-column label="手机号" prop="healthcheckMobile"></el-table-column>
      <el-table-column label="状态" prop="orderStatusDescription"></el-table-column>
      <el-table-column label="套餐" prop="_comboName"></el-table-column>
      <el-table-column label="预约时间" :formatter="formatter"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="{row}">
          <el-button type="text" size="mini" @click="sub(row)" v-if="showYuyueBtn(row.orderStatus)">预约
          </el-button>
          <el-button type="text" size="mini" @click="genggai(row)" v-if="showGenggaiBtn(row.orderStatus)">更改
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pt10">
      <el-pagination :total="page.total" :current-page="page.pageNum" background
                     @current-change="pageChange"></el-pagination>
    </div>
  </el-dialog>
</template>

<script>
import {DiaLogMixin} from "../../../common/lib/mixins/dialog-base";
import {healthcheckService} from "../services/healthcheck";
import {timeFormat} from "../../../common/lib/utils";
import dayjs from 'dayjs';

export default {
  name: "dialog-tj-yuyue",
  mixins: [DiaLogMixin],
  data() {
    return {
      info: {},
      form: {
        comboName: '',
        pageNum: 1,
        pageSize: 10
      },
      page: {},
      list: [],
      k: "healthcheckerName",
      ks: [
        {id: 'healthcheckerName', name: '姓名'},
        {id: 'mobile', name: '手机号'},
        {id: 'idcard', name: '身份证'}
      ],
      val: ''
    }
  },
  methods: {
    showYuyueBtn(status) {
      return ["WAIT_HANDLE"].includes(status);
    },

    showQuxiaoBtn(status) {
      return ["WAIT_CHECK"].includes(status);
    },

    showGenggaiBtn(status) {
      return ["OVERDUE", "WAIT_CHECK"].includes(status);
    },

    formatter(row) {
      return timeFormat(row.appointmentDate, '%Y-%m-%d');
    },
    open(data) {
      this.show();
      this.info = data;
      this.getData();
    },
    formReset() {
      this.$set(this.form, this.k, undefined);
      this.k = this.ks[0].id;
      this.val = '';
      this.form.comboName = "";
      this.form.pageNum = 1;
      this.getData();
    },
    pageChange(pageNum) {
      this.form.pageNum = pageNum;
      this.getData();
    },

    genggai(data) {
      const fStr = 'YYYY-MM-DD';
      this.$confirm(`
            <p>是否将原预约日期：${dayjs(data.appointmentDate).format(fStr)}</p>
            <p>改到：${this.info.date}</p>
        `, {
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.sub(data);
      })
    },

    async sub(data) {
      const {info} = this;
      let {code, list} = await healthcheckService.tjPreBook({
        healthcheckOrderId: data.platOrderId,
        startTime: info.date,
        endTime: info.date,
        healthcheckTeamId: this.healthcheckBookTeam.platTeamId
      });
      if (code !== '0') {
        return;
      }

      if (!list || !list.length) return;

      const {numberSourceBookedStatus: status, lackMedicalSkillsComboItemList} = list[0] || {};
      if (status !== 'NORMAL') {
        return this.$emit('error', status, lackMedicalSkillsComboItemList);
      }


      let {code: c} = await healthcheckService.tjPlatOrderBook({
        healthcheckOrderId: data.platOrderId,
        comboName: data._comboName,
        timeIntervalId: info.timeIntervalId,
        numberSourceId: info.numberSourceId
      });
      if (c === '0') {
        this.$message.success('预约成功');
        this.$emit('ok', 1);
        this.hide();
      }
    },

    async getData() {
      let {form, k, val, ks} = this;
      ks.forEach(r => {
        this.$set(form, r.id, undefined);
      });
      if (val) this.$set(form, k, val);
      form.platTeamId = this.healthcheckBookTeam.id;
      const {list, page} = await healthcheckService.tjOrderList(form);
      this.list = list;
      this.page = page;
    }
  },
}
</script>

<style scoped>

</style>
